import { isDev, isProd } from "@sista/library-stasi";

export const featureOrganizationAdmin = true;

export const featureAlternativeRegistration = true;
export const featureNiaLogin = true;
export const featureShowNiaButtonForAll = true;
export const featureOvereniIdentityProPrirazeniOrganizace = isProd();
export const featureZobrazeniProjektu = true;
